<template>
  <div>
    <b-table
      sticky-header
      small
      id="henjuka-table"
      ref="table"
      bordered
      outlined
      :items="henjukaData"
      :fields="fields"
      :tbody-tr-class="rowClass"
      responsive="md">
        <template v-slot:cell(done_at)="row">
            <b-form-group class="mb-0">
                <span v-html="row.item.done_at"></span>
                <hr>
                <b-form-input
                    v-model="row.item.done_at"
                    type="date"
                    id="doneAtInput"
                ></b-form-input>
            </b-form-group>
        </template>
        <template v-slot:cell(done_at_time)="row">
            <b-form-group class="mb-0">
                <span v-html="row.item.done_at_time"></span>
                <hr>
                <b-form-input
                    v-model="row.item.done_at_time"
                    type="time"
                    id="doneAtTimeInput"
                ></b-form-input>
            </b-form-group>
        </template>
        <template v-slot:cell(done_workload)="row">
            <b-form-group class="mb-0">
                {{row.item.done_workload}}
                <hr>
                <b-form-input
                    v-model="row.item.done_workload"
                    type="number"
                    min="0"
                    id="doneWorkloadInput"
                ></b-form-input>
            </b-form-group>
        </template>

        <template v-slot:cell(order_type)="row">
          <span class="badge badge-pill badge-warning">
            {{row.item.order_type}}
          </span>
        </template>

        <template v-slot:cell(register)="row">
            <b-button size="sm" @click="save(row.item)" variant="primary" class="mr-2">
                Enregistrer
            </b-button>
        </template>
    </b-table>
  </div>
</template>

<script>
import engineering from '../../api/engineering.vue'
import moment from 'moment'

export default {
  name: 'henjukaSupply',
  data () {
    return {
        henjukaData: null,
        fields: [
            { key: 'code', label: 'référence', sortable: true },
            { key: 'index', label: 'index', sortable: true },
            { key: 'created_at', label: 'crée le', sortable: true },
            { key: 'updated_at', label: 'modifié le', sortable: true },
            { key: 'proceed_at', label: 'poursuite le', sortable: true },
            { key: 'estimated_at', label: 'estimé au', sortable: true },
            { key: 'done_at', label: 'terminé le', sortable: true },
            { key: 'done_at_time', label: 'terminé à', sortable: true },
            { key: 'estimated_workload', label: 'charge de travail estimée', sortable: true },
            { key: 'done_workload', label: 'charge de travaile réelle', sortable: true },
            { key: 'supplier', label: 'fournisseur', sortable: true },
            { key: 'internal_supplier', label: 'fournisseur interne', sortable: true },
            { key: 'order_type', label: 'type de commande', sortable: true },
            { key: 'designation', label: 'désignation', sortable: true },
            { key: 'register', label: 'mise à jour', sortable: false }
        ],
        actif : '<span class="badge badge-pill badge-success"> actif </span>'
    }
  },
  methods: {
    save(item) {
        engineering.updateKanban({'code': item.code, 'done_at': item.done_at, 'done_at_time': item.done_at_time, 'done_workload': item.done_workload}).then(res => {
            this.makeToast("Henjunka modifié !")
            this.$emit('success')
        }).catch((error) => {
            if ( error.response.status == 415) {
                this.$toasted.error(" Modification non prise en compte", {
                    theme: "bubble",
                    position: "top-right",
                    duration : 5000
                });
            } else {
                this.$toasted.error(" Une erreur est survenue " + error, {
                    theme: "bubble",
                    position: "top-right",
                    duration : 5000
                });
            }
        })
    },
    /*getDuration (then, now) {
      const ms = moment(now, 'YYYY/MM/DD HH:mm:ss').diff(
        moment(then, 'YYYY/MM/DD HH:mm:ss')
      )
      const d = moment.duration(ms)
      const s = Math.floor(d.asHours()) + moment.utc(ms).format(':mm:ss')
      if (s !== 'NaNInvalid date') {
        return s
      } else {
        return 'actif'
      }
    },*/
    get_henjuka_supply() {
      engineering
        .getKanban()
        .then(res => {
            this.henjukaData =
            res.data.cards.map(obj => ({
                ...obj,
                created_at: moment(obj.created_at)
                .locale('FR')
                .format('Do MMMM YYYY, kk:mm'),
                updated_at:
                    moment(obj.updated_at)
                    .locale('FR')
                    .format('Do MMMM YYYY, kk:mm:ss') === 'Invalid date'
                    ? ''
                    : moment(obj.updated_at)
                      .locale('FR')
                      .format('Do MMMM YYYY, kk:mm'),
                proceed_at:
                    moment(obj.proceed_at)
                    .locale('FR')
                    .format('Do MMMM YYYY, kk:mm:ss')=== 'Invalid date'
                    ? ''
                    : moment(obj.updated_at)
                      .locale('FR')
                      .format('Do MMMM YYYY, kk:mm'),
                estimated_at:
                    moment(obj.estimated_at)
                    .locale('FR')
                    .format('Do MMMM YYYY, kk:mm'),
                done_workload:
                    obj.done_workload === null
                    ? 0
                    : obj.done_workload,
                done_at:
                    moment(obj.done_at)
                    .locale('FR')
                    .format('Do MMMM YYYY, kk:mm:ss') === 'Invalid date'
                    ? this.actif
                    : moment(obj.done_at)
                      .locale('FR')
                      .format('Do MMMM YYYY'),
                done_at_time:
                    moment(obj.done_at)
                    .locale('FR')
                    .format('Do MMMM YYYY, kk:mm:ss') === 'Invalid date'
                    ? this.actif
                    : moment(obj.done_at)
                      .utc()
                      .format('kk:mm')
            }))
        })
    },
    rowClass(item, type) {
      if (!item || type !== 'row') return
      if (item.updated_at !== '') return 'table-secondary'
    }
  },
  mounted: function () {
    this.get_henjuka_supply()
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/andon/henjuka_supply.vue